<template>
    <div 
        class="dropdown"
        :class="{show: showMenu}"
        @mouseenter="showMenu = true"
        @mouseleave="showMenu = false"
        @click="showMenu=!showMenu"
    >
        <div class="dropdown-toggle">{{ locale === 'cs' ? 'CZ' : locale.toUpperCase() }}</div>
        <img 
            src="../../assets/svg/dropdownIcon.svg" 
            alt="" 
            class="dropdown-icon"
        >
        <ul class="dropdown-menu">
            <li
                v-for="aLocale in availableLocales"
                v-show="aLocale !== locale"
                :key="`locale-${aLocale}`"
                class="dropdown-menu__link"
                @click="locale = aLocale"
            >
                {{ aLocale === 'cs' ? 'CZ' : aLocale.toUpperCase() }}
            </li>
        </ul>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
import { ref, watch } from 'vue';

const store = useStore()
const { availableLocales, locale } = useI18n() 
const showMenu = ref(false)

watch(locale, (val) => {
    window.localStorage.setItem('language', val)
})

</script>

<style lang="scss" scoped>

</style>